import { InternalEvent } from '../../../enums';
import {
  InternalDialogClosePayload,
  InternalEventPayloadValidator,
} from '../../../types';

export const internalDialogClosePayloadValidator: InternalEventPayloadValidator<
  InternalEvent.DIALOG_CLOSE
> = (payload: unknown): payload is InternalDialogClosePayload =>
  typeof payload === 'undefined';
